import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { LinkyModule } from 'ngx-linky';
import { ReplaceEmojisPipe } from '../../../../sb-tools/typescript/pipes/replace-emoji/replace-emojis.pipe';
import { SafeHtmlPipe } from '../../../../sb-tools/typescript/pipes/safe-html.pipe';
import { NewLinePipe } from '../../../../sb-tools/typescript/pipes/new-line.pipe';

@Component({
    selector: 'app-highlight-reply-mention',
    templateUrl: './highlight-reply-mention.component.html',
    styleUrls: ['./highlight-reply-mention.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LinkyModule, ReplaceEmojisPipe, SafeHtmlPipe, NewLinePipe],
})
export class HighlightReplyMentionComponent implements OnChanges {
    @Input() mentionedUsers;
    @Input() message;

    commentString;
    mentionedUser;

    ngOnChanges() {
        let newCommentText = this.message;

        this.mentionedUsers?.forEach((mentionedUser) => {
            this.mentionedUser = mentionedUser;

            const mentionedUserRegex = new RegExp('\\{User:' + mentionedUser.id + '\\}', 'g');

            const linkToUserInfo =
                '<a class="user-info-link mention-user mention" userId="' +
                mentionedUser.id +
                '">' +
                mentionedUser.name +
                '</a>';

            newCommentText = newCommentText.replace(mentionedUserRegex, linkToUserInfo);
        });

        this.commentString = newCommentText;
    }
}
